import React, { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface BUGuardProps {
  children: ReactNode;
}

const BUGuard: React.FC<BUGuardProps> = ({ children }) => {
  const location = useLocation();
  const businessUnitGuid = localStorage.getItem('BusinessUnitGuid');
  const businessUnitName = localStorage.getItem('BusinessUnitName');
  const businessUnitCode = localStorage.getItem('BusinessUnitCode');

  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      // If another tab modifies the BU, force a reload to sync this tab's React state
      if (event.key === 'BusinessUnitGuid' || event.key === 'BusinessUnitName' || event.key === 'BusinessUnitCode') {
        window.location.reload();
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  if (!businessUnitGuid || !businessUnitName || !businessUnitCode) {
    // Redirect to select-bu, saving the current location they were trying to go to
    return <Navigate to="/selectbusinessunit" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default BUGuard;
